import { atom } from 'recoil';

// 활성 팀: null = 기본 견적서 모드, 객체 = 팀 정보 (team_id, name, my_role 등)
// localStorage 에 team_id 만 저장하고 새로고침 시 /api/teams/mine 으로 다시 불러와 sync
export const ActiveTeamAtom = atom({
  key: 'ActiveTeamAtom',
  default: null,
  effects: [
    ({ setSelf, onSet }) => {
      // 초기 로드: localStorage 에서 team_id만 복원 (실제 팀 정보는 fetch 후 set)
      onSet((newValue) => {
        try {
          if (newValue && newValue.team_id) {
            localStorage.setItem('estimate-active-team-id', String(newValue.team_id));
          } else {
            localStorage.removeItem('estimate-active-team-id');
          }
        } catch {
          // ignore
        }
      });
    },
  ],
});

// 내가 소속된 팀 목록 캐시
export const MyTeamsAtom = atom({
  key: 'MyTeamsAtom',
  default: [],
});

// 팀 모달 열림 상태 (탭: 'mine' | 'create' | 'join' | 'manage')
export const TeamModalAtom = atom({
  key: 'TeamModalAtom',
  default: { open: false, tab: 'mine', manageTeamId: null },
});

// 트리 변경 버전 카운터 — TeamTreeManager 에서 카테고리/항목 수정 시 +1.
// TeamWizardApp 등 외부 화면이 이 값을 watch 해 자동 재로드.
export const TeamTreeVersionAtom = atom({
  key: 'TeamTreeVersionAtom',
  default: 0,
});
